export enum DocumentOwnerTypeEnum {
    Player = 1,
    Other = 2
}
